import React from "react";
import "./buttonComponent.scss";

const Button = ({ className, onClick, children, ...rest }) => {
  return (
    <button
      type="button"
      className={`customButton ${className || ''}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
